import { render, staticRenderFns } from "./Restrictions.vue?vue&type=template&id=3440a64d&scoped=true"
import script from "./Restrictions.vue?vue&type=script&lang=js"
export * from "./Restrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3440a64d",
  null
  
)

export default component.exports